export var calculateEAN13CheckDigit = function (code) {
    if (code.length !== 12) {
        throw new Error("EAN13 code must be 12 digits long for check digit calculation");
    }
    var sum = 0;
    for (var i = 0; i < 12; i++) {
        var digit = parseInt(code[i], 10);
        sum += i % 2 === 0 ? digit : digit * 3;
    }
    var checkDigit = (10 - (sum % 10)) % 10;
    return checkDigit.toString();
};
export var validateEAN13 = function (code) {
    if (code.length !== 13) {
        return false;
    }
    if (!/^\d+$/.test(code)) {
        return false;
    }
    var providedCheckDigit = code[12];
    var calculatedCheckDigit = calculateEAN13CheckDigit(code.substring(0, 12));
    return providedCheckDigit === calculatedCheckDigit;
};
